import { API_ROUTES } from "../utils/constants"
import apiHelper from "./apiHelper"

export function createUser(data) {
    return apiHelper({ method: "post", path: API_ROUTES.USER.CREATE_USER, data })
}

export function editUser(data) {
    return apiHelper({ method: "post", path: API_ROUTES.USER.EDIT_USER, data })
}

export function fullActivateUser(userId) {
    return apiHelper({ method: "post", path: API_ROUTES.USER.FULL_ACTIVATE_USER, data: { userId } })
}

export function fullSuspendUser(userId) {
    return apiHelper({ method: "post", path: API_ROUTES.USER.FULL_SUSPEND_USER, data: { userId } })
}

export function activateUser(userId) {
    return apiHelper({ method: "post", path: API_ROUTES.USER.ACTIVATE_USER, data: { userId } })
}

export function suspendUser(userId) {
    return apiHelper({ method: "post", path: API_ROUTES.USER.SUSPEND_USER, data: { userId } })
}

export function deleteUser(userId) {
    return apiHelper({ method: "delete", path: API_ROUTES.USER.DELETE_USER, data: { userId } })
}

export function authenticate(data) {
    return apiHelper({ method: "post", path: API_ROUTES.USER.AUTHENTICATE, data })
}

export function changeUserGlobalCommands(customCommands) {
    return apiHelper({ method: "post", path: API_ROUTES.SETTINGS.CUSTOM_COMMANDS.UPDATE, data: { customCommands } })
}

export function changeUserPassword(data) {
    return apiHelper({ method: "post", path: API_ROUTES.USER.CHANGE_USER_PASSWORD, data })
}

export function getAllUsers() {
    return apiHelper({ method: "get", path: API_ROUTES.USER.GET_ALL_USERS })
}

// export function getIsActive(token) {
//     return new Promise((resolve, reject) => {
//         let config = {
//             method: "post",
//             maxBodyLength: Infinity,
//             url: `${API_ROUTES.IS_ACTIVE}?token=${token}`,
//         }

//         axios
//             .request(config)
//             .then((res) => {
//                 resolve(res.data)
//             })
//             .catch((error) => {
//                 console.error(error)
//                 reject(error)
//             })
//     })
// }

export function genToken(data) {
    return apiHelper({ method: "post", path: API_ROUTES.USER.TOKEN.CREATE, data })
}

export function deleteToken(tokenId) {
    return apiHelper({ method: "delete", path: API_ROUTES.USER.TOKEN.DELETE, data: { tokenId } })
}

export function getTokenList() {
    return apiHelper({ method: "get", path: API_ROUTES.USER.TOKEN.GET_TOKEN_LIST })
}

export function getUserGlobalCommands() {
    return apiHelper({ method: "get", path: API_ROUTES.SETTINGS.CUSTOM_COMMANDS.GET })
}

export function getCredentials() {
    return apiHelper({ method: "get", path: API_ROUTES.USER.GET_CREDENTIALS })
}
